'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';

// UI
import { Input } from '@components/form/input/input';
import { Select, ISelectOption } from '@components/form/select/select';
import { Option } from '@components/option';
import { Icon } from '@components/icon';
import { IconNames } from '@components/icon';
import { ListingReviewSortOptions } from '@gql';
import { ButtonIcon } from '@components/button-icon';
export type SortOption = {
  label: string;
  value: string;
};
// Sort options for reviews
const sortOptions: SortOption[] = [{
  label: 'Most Recent',
  value: ListingReviewSortOptions.DateNewestFirst
}, {
  label: 'Oldest First',
  value: ListingReviewSortOptions.DateOldestFirst
}, {
  label: 'Highest Rating',
  value: ListingReviewSortOptions.RatingHighestFirst
}, {
  label: 'Lowest Rating',
  value: ListingReviewSortOptions.RatingLowestFirst
}];
export type ReviewsSearchSortProps = {
  searchValue: string;
  sortValue: ListingReviewSortOptions | null;
  onSearchChange: (value: string) => void;
  onSortChange: (option: ListingReviewSortOptions | null) => void;
};
export const ReviewsSearchSort: React.FC<ReviewsSearchSortProps> = t0 => {
  const $ = _c(32);
  const {
    searchValue,
    sortValue,
    onSearchChange,
    onSortChange
  } = t0;
  const [localSearchValue, setLocalSearchValue] = React.useState(searchValue);
  let t1;
  let t2;
  if ($[0] !== searchValue) {
    t1 = () => {
      setLocalSearchValue(searchValue);
    };
    t2 = [searchValue];
    $[0] = searchValue;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event => {
      setLocalSearchValue(event.target.value);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleSearchChange = t3;
  let t4;
  if ($[4] !== localSearchValue || $[5] !== onSearchChange) {
    t4 = event_0 => {
      if (event_0.key === "Enter") {
        onSearchChange(localSearchValue);
        event_0.currentTarget.blur();
      }
    };
    $[4] = localSearchValue;
    $[5] = onSearchChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSearchKeyDown = t4;
  let t5;
  if ($[7] !== onSearchChange) {
    t5 = () => {
      setLocalSearchValue("");
      onSearchChange("");
    };
    $[7] = onSearchChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleClearSearch = t5;
  let t6;
  if ($[9] !== onSortChange) {
    t6 = (_name, option) => {
      onSortChange(option ? option.value as ListingReviewSortOptions : null);
    };
    $[9] = onSortChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleSortChange = t6;
  let t7;
  bb0: {
    if (!sortValue) {
      t7 = null;
      break bb0;
    }
    let t8;
    if ($[11] !== sortValue) {
      t8 = sortOptions.find(option_0 => option_0.value === sortValue);
      $[11] = sortValue;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    const foundOption = t8;
    let t9;
    if ($[13] !== foundOption) {
      t9 = foundOption ? {
        label: foundOption.label,
        value: foundOption.value
      } : null;
      $[13] = foundOption;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    t7 = t9;
  }
  const currentSortValue = t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Icon name={IconNames.MAGNIFYING_GLASS} className="text-gray-main" size="sm" />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== handleClearSearch || $[17] !== localSearchValue) {
    t9 = localSearchValue ? <ButtonIcon variant="text" color="gray" size="sm" icon={IconNames.CIRCLE_X} iconSize="lg" ariaLabel="Clear search" ariaDescribedby="clear-reviews-search-input" onClick={handleClearSearch} className="pe-0 ps-0" /> : <ButtonIcon variant="text" size="sm" icon={IconNames.CIRCLE_X} iconSize="lg" ariaLabel="Clear search" ariaDescribedby="clear-reviews-search-input" className="invisible pe-0 ps-0" />;
    $[16] = handleClearSearch;
    $[17] = localSearchValue;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== handleSearchKeyDown || $[20] !== localSearchValue || $[21] !== t9) {
    t10 = <div className="flex-col w-1/2 lg:w-2/3"><Input name="search-reviews" placeholder="Search" value={localSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchKeyDown} leftContent={t8} rightContent={t9} showLabel={false} className="w-full border-gray-light" /></div>;
    $[19] = handleSearchKeyDown;
    $[20] = localSearchValue;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== sortValue) {
    t11 = sortOptions.map(option_1 => <Option key={option_1.value} value={option_1} selected={String(sortValue) === String(option_1.value)} className="text-gray-main">{option_1.label}</Option>);
    $[23] = sortValue;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== currentSortValue || $[26] !== handleSortChange || $[27] !== t11) {
    t12 = <div className="flex-col w-1/2 lg:w-1/3"><Select name="sort-reviews" value={currentSortValue} onChange={handleSortChange} showLabel={false} className="w-full border-gray-light [&_[id='sort-reviews-select']]:!font-normal [&_[id='sort-reviews-select']]:!text-gray-main">{t11}</Select></div>;
    $[25] = currentSortValue;
    $[26] = handleSortChange;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t10 || $[30] !== t12) {
    t13 = <div className="flex flex-cols-2 sm:flex-row gap-2 lg:gap-4 w-full justify-between">{t10}{t12}</div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};